module.exports = __webpack_public_path__ + "img/voucher.6a8da19c.png";